import makeCommandDispatcher from "web/core/apollo/makeCommandDispatcher";
import { compose } from "recompose";
import { graphql } from "react-apollo";
import { trackGlobalPage } from "web/theme/components/helpers/AnalyticsV4/TrackAnlyticsV4";

const EnhancePasswordRequest = ({
  PasswordRequestMutation,
  PasswordRequestConfigurationQuery,
}) =>
  compose(
    trackGlobalPage(),
    makeCommandDispatcher({
      initiatePasswordReset: (props) => (data) => {
        return {
          options: {
            mutation: PasswordRequestMutation,
            variables: data,
          },
        };
      },
    }),
    graphql(PasswordRequestConfigurationQuery, {
      props: ({ data }) => {
        return {
          loading: data.loading,
          loginSubscriptionDescription:
            data.storeConfiguration &&
            data.storeConfiguration.loginSubscriptionDescription,
          backgroundImage:
            data.storeConfiguration &&
            data.storeConfiguration.loginSubscriptionBackgroundMedia &&
            data.storeConfiguration.loginSubscriptionBackgroundMedia.url,
        };
      },
    })
  );

export default EnhancePasswordRequest;
